module.exports = __webpack_public_path__ + "img/logo-mobile.e192b24e.svg";